import i18n from '@/utils/i18n';
import React from 'react';
import { BORDER_RADIUS_SMALL, FONTS } from '@/styles';
import { createStyles } from '@/contexts/theme-context';
import {
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { VOLUME_PROMOTION_CARD_HEIGHT } from './volume-promotion-list-item';

interface Props {
  count: number;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

const CARD_WIDTH = Math.round((VOLUME_PROMOTION_CARD_HEIGHT * 157) / 196);

export const VolumePromotionsSeeAllCard: React.FC<Props> = ({
  count,
  onPress,
  style,
}) => {
  const [styles] = useStyles();

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.wrapper, style]}
      testID="promotions-see-all-card"
    >
      <View style={styles.card}>
        <Text style={styles.text}>{i18n.t('see_all')}</Text>
        <Text style={styles.text}>
          {i18n.t('see_all_promotions_count', { count })}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  card: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderColor: theme.sk.color.border.primary,
    borderRadius: BORDER_RADIUS_SMALL,
    borderWidth: 1,
    flex: -1,
    height: VOLUME_PROMOTION_CARD_HEIGHT,
    justifyContent: 'center',
    width: CARD_WIDTH,
  },
  text: {
    ...FONTS.primarySemiBold,
    color: theme.colors.primary,
    fontSize: theme.fontSizes.medium,
    lineHeight: 22,
    textAlign: 'center',
  },
  wrapper: {
    height: VOLUME_PROMOTION_CARD_HEIGHT,
    paddingBottom: 8,
  },
}));
